import { ProsBanner } from "modules/system/sections/pros/operations/banner";
import { ProsDeployMgmt } from "modules/system/sections/pros/site-intergration/deploy-management";
import { SystemProsSections } from "modules/system/sections/pros/SystemProsSections";
import React from "react";
import { Route, Routes } from "react-router-dom";

import { SideNavLayout } from "@layouts/SideNavLayout";

import { SystemBreadcrumbs } from "../../breadcrumbs/SystemBreadcrumbs";
import { SystemProsTabs } from "./system-pros-tabs.constants";

export const SystemProsRoutes: React.FC = () => (
  <SideNavLayout nav={<SystemProsSections />}>
    <Routes>
      <Route element={<SystemBreadcrumbs tabs={SystemProsTabs} />}>
        {/* Operations Tabs */}
        <Route
          path={SystemProsTabs.Operations.Banner.id}
          element={<ProsBanner />}
        />

        {/* Site Intergration Tabs */}
        <Route
          path={SystemProsTabs.SiteIntegration.DeploymentManagement.id}
          element={<ProsDeployMgmt />}
        />
      </Route>
    </Routes>
  </SideNavLayout>
);
